import { ColumnRank, ColumnBib, ColumnName, ColumnNoc, ColumnWarnings, ColumnResult, ColumnRecords, ColumnExpander, ColumnQualification } from "components/common/TableColumns"
import { findArray } from 'helpers/utils'
import Label from "components/general/Label"


function getCell(row, attempt) {
    let cell = null
    if (!!row) {
        let bestAttemp = row?.extendedResults && findArray(row.extendedResults, { er_code: ['BEST_ATTEMPT_NUM'] }).er_value
        let value = findArray(row.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [attempt.toString()] }).er_value
        cell = <span className={attempt == bestAttemp ? 'fw-bold text-success' : ''}>{value}</span>
    }
    return cell

}

export function TableColumns(columnsAdded) {
    let numCols = findArray(columnsAdded, { ei_code: ['INTERMEDIATES_TOTAL'] }).ei_value
    let columnsExt = []
    for (let i = 0; i < numCols; i++) {
        let attempt = i + 1;
        columnsExt.push(
            {
                Header: attempt,
                accessor: (props) => (
                    props?.extendedResults
                        ? findArray(props.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [attempt.toString()] }).er_value
                        : ''
                ),
                Cell: (props) => (
                    getCell(props.cell.row.original, attempt)
                ),
                key: 'Attempts' + attempt,
                id: 'Attempts' + attempt,
                className: 'result',
                headerClassName: 'text-center w-5',
            },
        )
    }

    return (
        [
            ColumnRank({}),
            {
                Header: <Label data={'HeaderOrder'} />,
                className: 'text-end',
                headerClassName: 'text-end w-5',
                disableSortBy: true,
                id: 'StartOrder',
                remove: false,
                accessor: (props) => {
                    let orderCurrent = findArray(props?.extendedResults, { er_code: ['ORDER_CURRENT'] })?.er_value
                    return orderCurrent ? orderCurrent : props?.startSortOrder
                },
                Cell: (props) => {
                    let orderCurrent = findArray(props?.cell?.row?.original?.extendedResults, { er_code: ['ORDER_CURRENT'] })?.er_value
                    return orderCurrent ? orderCurrent : props?.cell?.row?.original?.startOrder
                }
            },
            ColumnBib({ className: 'text-end result' }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnWarnings({}),
            ...columnsExt,
            ColumnResult({ label: 'HeaderBest' }),
            ColumnQualification({}),
            ColumnRecords({}),

        ]
    )
}



export default TableColumns
